import { useRef, useCallback } from 'react';
import { useMeetingSelector } from '../meeting/meetingProviderContextDef';
import { rejectNotJoined } from '../utils';

const selectMeeting = s => s.meeting;

const useFile = () => {
  const meeting = useMeetingSelector(selectMeeting);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;

  const uploadBase64File = useCallback(({ base64Data, token, fileName }) => {
    if (!meetingRef.current) return rejectNotJoined('uploadBase64File');
    return meetingRef.current.uploadBase64File({
      base64Data,
      token,
      fileName
    });
  }, []);

  const fetchBase64File = useCallback(({ url, token }) => {
    if (!meetingRef.current) return rejectNotJoined('fetchBase64File');
    return meetingRef.current.fetchBase64File({ url, token });
  }, []);

  return { uploadBase64File, fetchBase64File };
};

export default useFile;
